<template>
  <el-form-item
    :key="form.key"
    :label="form.cname+':'"
    :prop="prop"
    :rules="rule">
    <div
      v-if="status === 'edit'"
      style="width: 100%">
      <el-date-picker
        v-model="form.fieldValue"
        :disabled="form.checked"
        style="width: 50%"
        type="date"
        :clearable="!form.mandatory"
        placeholder="选择日期">
      </el-date-picker>
      <el-checkbox
        v-model="form.checked"
        style="margin-left: 5px;">详见包装</el-checkbox>
    </div>
    <span v-else>
      <span v-if="form.checked">详见包装</span>
      <span v-else>{{ form.fieldValue | dateformat('YYYY-MM-DD') }}</span>
    </span>
  </el-form-item>
</template>

<script>
export default {
  name: 'FormDateCheckbox',
  props: {
    item: {
      type: Object,
      required: true,
      default() {
        return {}
      }
    },
    prop: {
      type: String,
      required: true
    },
    status: {
      type: String,
      default: 'edit'
    }
  },
  computed: {
    form: {
      get() {
        return this.item
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    rule() {
      return [
        {
          validator: (rule, value, callback) => {
            if (this.form.checked) {
              callback()
            } else {
              if (this.form.mandatory && !this.form.fieldValue) {
                callback(new Error(this.form.cname + '不能为空'))
              } else {
                callback()
              }
            }
          },
          trigger: 'blur'
        }
      ]
    }
  },
  watch: {
    'form.checked'(val) {
      if (val) {
        this.form.fieldValue = null
      }
    }
  },
  methods: {
    change(val) {
      this.form.checked = val
    }
  }
}
</script>
